import { Link, useLocation } from 'react-router-dom';
import { authReturnLocation } from '../../auth/authReturn';
import { useTravelTranslation } from '../../app/TravelLocaleContext';

/**
 * Explore 內需登入的分頁牆：不擴大 Guest 權限，只清楚說明並保留 Return URL。
 */
export default function ExploreGuestGate({
  titleKey = 'travel.discoverGuest.title',
  bodyKey = 'travel.discoverGuest.body',
  testId = 'explore-guest-wall',
  titleId = 'explore-guest-title',
  showBrowseForYou = true,
}) {
  const { t } = useTravelTranslation();
  const location = useLocation();

  return (
    <section className="explore-login" aria-labelledby={titleId} data-testid={testId}>
      <span aria-hidden="true">✦</span>
      <h2 id={titleId}>{t(titleKey)}</h2>
      <p>{t(bodyKey)}</p>
      <div className="explore-login__actions">
        <Link
          className="explore-login__primary"
          to="/login"
          state={{ from: authReturnLocation(location) }}
        >
          {t('travel.discoverGuest.cta')}
        </Link>
        {showBrowseForYou ? (
          <Link
            className="explore-login__secondary"
            to="/explore?tab=for-you"
            data-testid="explore-guest-browse-for-you"
          >
            {t('travel.discoverGuest.browseForYou')}
          </Link>
        ) : null}
      </div>
      <p className="explore-login__footnote">{t('travel.discoverGuest.footnote')}</p>
    </section>
  );
}
